const statusColorMap = {
	IN_PROGRESS: "bg-yellow-300 text-white",
	ACTIVE: "bg-green-700 text-white",
	INACTIVE: "bg-slate-200 text-grey-800",
};
export function Chip({ status, classes, children }) {
	const statusClasses = statusColorMap[status];
	return <div className={`rounded-sm px-3 py-1 ${classes} ${statusClasses}`}>{children}</div>;
}
